import React from "react";
import { Grid } from "@mui/material";
import utilities from "../../utility/utilities";
import { validations } from "../../utility/constants/errors/messages";
import MultiValueTextField from "../commoncomponents/MultiValueTextField";

const VendorContact = ({
  phone,
  contactPerson,
  email,
  errors,
  errorMessages,
  setErrors,
  setErrorMessages,
  setEmail,
  setPhone,
  setContactPerson,
  isView,
  setIsChanged,
  emailMultiValues,
  constactPersonMultiValues,
  setEmailMultiValues,
  phoneMultiValues,
  setPhoneMultiValues,
  setContactPersonMultiValues,
}) => {
  const handleEmailChange = (value) => {
    setIsChanged(true);
    setEmail(value);
    if (value) {
      setErrors((prev) => ({ ...prev, email: false }));
      setErrorMessages((prev) => ({ ...prev, email: "" }));
    }
  };
  const handlePhoneChange = ( value) => {
    setIsChanged(true);
    setPhone(value);
    if (!value) {
      setErrors((prev) => ({ ...prev, phone: false }));
      setErrorMessages((prev) => ({ ...prev, phone: "" }));
    }
  };
  const handleContactPersonChange = (value) => {
    setIsChanged(true);
    setContactPerson(value);
    if (value) {
      setErrors((prev) => ({ ...prev, contactPerson: false }));
      setErrorMessages((prev) => ({ ...prev, contactPerson: "" }));
    }
    if (utilities.validateTextField(value) || !value) {
      setErrors((prev) => ({ ...prev, contactPerson: false }));
      setErrorMessages((prev) => ({ ...prev, contactPerson: "" }));
    } else if (!utilities.validateTextField(value)) {
      setErrors((prev) => ({ ...prev, contactPerson: true }));
      setErrorMessages((prev) => ({
        ...prev,
        contactPerson: validations.textfield,
      }));
    }
  };
  
  const emailValidate = (value) => {
    if (utilities.validateEmail(value) || !value) {
      setErrors((prev) => ({ ...prev, email: false }));
      setErrorMessages((prev) => ({ ...prev, email: "" }));
      return true
    } else if (!utilities.validateEmail(value)) {
      setErrors((prev) => ({ ...prev, email: true }));
      setErrorMessages((prev) => ({
        ...prev,
        email: validations.email,
      }));
      return false
    }
  };
  const phoneValidate = (value) => {
    if (utilities.validatePhoneNumber(value) || !value) {
      setErrors((prev) => ({ ...prev, phone: false }));
      setErrorMessages((prev) => ({ ...prev, phone: "" }));
      return true
    } else if (!utilities.validatePhoneNumber(value)) {
      setErrors((prev) => ({ ...prev, phone: true }));
      setErrorMessages((prev) => ({
        ...prev,
        phone: validations.phoneNumber,
      }));
      return false
    }
  };
  return (
    <Grid container spacing={4} mt={1}>
      <Grid item xs={6} md={4}>
        <MultiValueTextField
          label={"E-mail Address"}
          maxlength={60}
          input={email}
          value={emailMultiValues}
          onValueChange={handleEmailChange}
          onArrayChange={(array) => setEmailMultiValues(array)}
          error={errors.email}
          helperText={errorMessages.email}
          disabled={isView} 
          validate={emailValidate}
        />
      </Grid>
      <Grid item xs={6} md={4}>
        <MultiValueTextField
          label={"Handphone No."}
          maxlength={60}
          input={phone}
          disabled={isView} 
          value={phoneMultiValues}
          onValueChange={handlePhoneChange}
          onArrayChange={(array) => setPhoneMultiValues(array)}
          error={errors.phone}
          validate={phoneValidate}
          helperText={errorMessages.phone}
        />
      </Grid>
      <Grid item xs={6} md={4}>
        <MultiValueTextField
          label={"Contact Person"}
          maxlength={60}
          input={contactPerson}
          value={constactPersonMultiValues}
          validate={()=>true}
          onValueChange={handleContactPersonChange}
          onArrayChange={(array) => setContactPersonMultiValues(array)}
          error={errors.contactPerson}
          helperText={errorMessages.contactPerson}
          disabled={isView}
        />
      </Grid>
      
    </Grid>
  );
};

export default VendorContact;
